import { createSlice } from "@reduxjs/toolkit";

const { reducer, actions } = createSlice({
    name: "speedometer",
    initialState: {
        position: undefined,
    },
    reducers: {
        update(state, action) {
            state.position = action.payload;
        },
    },
});

export { actions as speedometerActions };
export { reducer as speedometerReducer };
